/**
 * Pulizia mirata del sessionStorage al cambio numero / ricollegamento WhatsApp.
 * Prima si chiamava sessionStorage.clear(), che cancellava lo stato di sessione
 * di tutto il CRM (filtri, bozze, chat di configurazione...). Qui si tolgono
 * solo le chiavi scritte dal codice WhatsApp:
 *   whatsapp_chats_backup, whatsapp_config_cache_<utente>_<org>,
 *   waha_config_cache_<utente>.
 */

export const WHATSAPP_SESSION_KEY_PREFIXES = ['whatsapp_', 'waha_'] as const;

type SessionStorageLike = Pick<Storage, 'length' | 'key' | 'removeItem'>;

export function isWhatsAppSessionKey(key: string): boolean {
  return WHATSAPP_SESSION_KEY_PREFIXES.some((p) => key.startsWith(p));
}

/** Rimuove le sole chiavi WhatsApp; ritorna quante ne ha tolte. Non lancia mai. */
export function clearWhatsAppSessionKeys(storage?: SessionStorageLike | null): number {
  try {
    const s = storage ?? (typeof window !== 'undefined' ? window.sessionStorage : null);
    if (!s) return 0;
    const keys: string[] = [];
    for (let i = 0; i < s.length; i++) {
      const k = s.key(i);
      if (k && isWhatsAppSessionKey(k)) keys.push(k);
    }
    keys.forEach((k) => s.removeItem(k));
    return keys.length;
  } catch {
    return 0;
  }
}
